import { useState } from 'react';

/**
 *
 * @returns {[boolean, () => void]}
 */
const useModal = () => {
  const [isShowing, setIsShowing] = useState(false);

  function toggle() {
    setIsShowing(prev => !prev);
  }

  return [isShowing, toggle];
};

export default useModal;
